import React, { useRef } from 'react';
import ClearIcon from '@mui/icons-material/Clear'; // MUI Filled Clear icon
import PropTypes from 'prop-types';

// Controlled SearchBar for main app, styled to match Sample App
const SearchBar = ({ onSearch, value = '', onChange }) => {
  const inputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch && value.trim()) {
      onSearch(value.trim());
    }
  };

  const handleClear = () => {
    if (onChange) onChange('');
    if (inputRef.current) inputRef.current.focus();
  };

  return (
    <form onSubmit={handleSubmit} className="relative w-full my-4">
      <div className="relative w-full">
        <div className="relative rounded-full p-1" style={{ background: '#3c0c57' }}>
          <input
            ref={inputRef}
            type="search"
            aria-label="Search educational resources for keywords"
            placeholder="Search educational resources for keywords..."
            className="pl-10 pr-16 py-1 md:py-1.5 text-base md:text-lg rounded-full border-none bg-transparent text-white placeholder:text-white/60 focus-visible:ring-0 w-full outline-none custom-hide-clear"
            value={value}
            onChange={e => onChange && onChange(e.target.value)}
            autoComplete="off"
          />
          <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-white/70" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
          <div className="absolute right-1 top-1/2 transform -translate-y-1/2 flex items-center space-x-1" style={{ right: '7px' }}>
            {value && (
              <button
                type="button"
                aria-label="Clear search input"
                onClick={handleClear}
                className="rounded-full h-8 w-8 flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white hover:bg-[#8034c4]"
                tabIndex={0}
                style={{ marginRight: '0px', background: '#3c0c57' }}
              >
                <ClearIcon style={{ color: '#fff' }} fontSize="small" />
              </button>
            )}
            <button type="submit" className="rounded-full h-8 w-8 p-0 flex items-center justify-center" aria-label="Search" style={{ background: '#8034c4' }}>
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                aria-hidden="true"
                style={{ color: '#fff' }}
              >
                <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" />
              </svg>
              <span className="sr-only">Search</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

SearchBar.propTypes = {
  onSearch: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SearchBar;
